// 字符串切割,处理空字符串与类型错误的问题 by shw
const split = function (value, separator, howmany) {
	if (typeof value !== 'string' || value === '') {
		return []
	}
	return String.prototype.split.apply(value, [separator, howmany])
}
// 字符串反转 by shw
const strReverse = (str) => {
	return str.split('').reverse().join('')
}
export default {
	split,
	strReverse
}



// WEBPACK FOOTER //
// ./src/lib/util/src/string.js